.bar {
  background: var(--surface);
  border-bottom: var(--outline);
}

.barInner,
.footerInner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  max-width: calc(var(--column) + 2 * var(--gutter));
  margin: 0 auto;
  padding: 10px var(--gutter);
}

.barInner {
  min-height: var(--bar-height);
}

.signIn {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  padding: 0 16px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--surface);
  font-size: 15px;
  font-weight: 700;
  text-decoration: none;
}

.main {
  display: flex;
  flex-direction: column;
  gap: 44px;
  max-width: calc(var(--column) + 2 * var(--gutter));
  margin: 0 auto;
  padding: 32px var(--gutter) 48px;
}

.hero {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 32px;
  align-items: center;
}

.heroText {
  display: flex;
  flex-direction: column;
  gap: 20px;
  min-width: 0;
}

.kicker {
  align-self: flex-start;
  padding: 6px 12px;
  border: 1.5px solid var(--ink);
  border-radius: 999px;
  background: var(--accent-soft);
  font-size: 13px;
  font-weight: 700;
}

.title {
  font-size: 36px;
  line-height: 1.05;
  letter-spacing: -0.02em;
}

.intro {
  font-size: 18px;
  line-height: 1.55;
  color: var(--ink-2);
}

.start {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
}

.startLink {
  display: inline-flex;
  align-items: center;
  min-height: 52px;
  padding: 0 22px;
  border: var(--outline);
  border-radius: var(--radius-control);
  background: var(--accent);
  color: var(--accent-ink);
  box-shadow: var(--shadow-button);
  font-size: 17px;
  font-weight: 700;
  text-decoration: none;
}

.startLink:active {
  box-shadow: none;
  transform: translate(3px, 3px);
}

.invited {
  font-size: 14px;
  line-height: 1.5;
  color: var(--ink-3);
}

.section {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.heading {
  font-size: 24px;
  letter-spacing: -0.01em;
}

.cards {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 16px;
}

.footer {
  background: var(--surface);
  border-top: var(--outline);
}

.footerInner {
  flex-direction: column;
  align-items: flex-start;
  padding-top: 24px;
  padding-bottom: 24px;
}

.footerLink {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  font-size: 14px;
  font-weight: 600;
}

.languages {
  font-size: 13px;
  color: var(--ink-3);
}

@media (min-width: 720px) {
  .main {
    gap: 64px;
    padding-top: 56px;
    padding-bottom: 72px;
  }

  .title {
    font-size: 52px;
  }

  .heading {
    font-size: 30px;
  }

  .cards {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .footerInner {
    flex-direction: row;
    align-items: center;
  }
}

/* The hero sets its text beside its picture only once the picture's column
 * can hold the desktop composition: from 960px the column is about 390px,
 * enough for the 360px disc. Below that the hero stays one column, text
 * above picture, so neither is squeezed (#115). */
@media (min-width: 960px) {
  .hero {
    grid-template-columns: minmax(0, 1.15fr) minmax(0, 1fr);
    gap: 56px;
  }
}
